import { css } from '@emotion/css';
import { theme } from 'antd';
import { useState } from 'react';

/** A rendered label, by default at 1.5× its 8-dpmm raster; white like the label stock, whatever the theme. */
export const LabelImage = ({ src, dimmed = false, scale = 1.5 }: { src: string; dimmed?: boolean; scale?: number }) => {
  const { token } = theme.useToken();
  const [width, setWidth] = useState<number>();

  const imageStyle = css`
    display: block;
    max-width: 100%;
    border: 1px solid ${token.colorText};
    background: #ffffff;
    opacity: ${dimmed ? 0.6 : 1};
    transition: opacity ${token.motionDurationMid};
  `;

  return (
    <img
      src={src}
      alt="Etikettenvorschau"
      className={imageStyle}
      style={{ width }}
      onLoad={e => setWidth(e.currentTarget.naturalWidth * scale)}
    />
  );
};
